<script setup lang="ts">
import { withBase } from "ufo";

const props = withDefaults(
  defineProps<{
    provider?: string;
    src?: string;
    width?: number | string;
    height?: number | string;
    caption?: string;

    type?: string;
    poster?: string;

    mini?: boolean;
  }>(),
  { caption: undefined }
);

const config = useRuntimeConfig();

const { currentPalette } = useTheme();

const url = computed(() =>
  props.provider === "directus"
    ? withBase(`/assets/${props.src}`, config.public.directus.url)
    : props.src
);

const poster = computed(() =>
  props.poster
    ? withBase(`/assets/${props.poster}`, config.public.directus.url)
    : undefined
);
</script>

<template>
  <figure class="content-video">
    <div class="content-video__wrapper overflow-hidden relative group/image">
      <template v-if="props.mini">
        <button
          class="block w-full h-auto p-0 m-0 cursor-zoom-in"
          @click="$emit('zoom')"
          title="Powiększ"
        >
          <NuxtPicture
            v-bind="{ provider, width, height }"
            :class="[currentPalette.bg]"
            :src="props.poster"
            :alt="caption"
            :img-attrs="{
              class: [
                'block w-full h-auto',
                'transition duration-500',
                'transform scale-[1.01] hover:scale-110 group-hover/image:scale-110 active:scale-100 group-active/image:scale-100 group-focus-within/image:scale-110',
              ],
              draggable: false,
            }"
            quality="65"
            preload
          />
        </button>

        <div
          :class="[
            'content-video__decoration',
            'pointer-events-none',
            'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
            'text-grey-500',
            'transition duration-500',
            'scale-[1.01] hover:scale-110 group-hover/image:scale-110 active:scale-100 group-active/image:scale-100 group-focus-within/image:scale-110',
          ]"
        >
          <svg
            width="233"
            height="165"
            viewBox="0 0 233 165"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="block w-[9.68958333333rem] h-auto"
          >
            <path
              opacity="0.6"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M32.0811 0.645386C14.4079 0.645386 0.0810547 14.9723 0.0810547 32.6454V132.355C0.0810547 150.028 14.4079 164.355 32.0811 164.355H200.633C218.306 164.355 232.633 150.028 232.633 132.355V0.645386H32.0811ZM85.0649 120.596L151.05 82.4999L85.0649 44.4035V120.596Z"
              fill="currentColor"
            />
          </svg>
        </div>

        <ContentImageActions vertical="bottom" horizontal="end">
          <ContentImageActionsButton @click="$emit('zoom')" title="Powiększ">
            <Icon name="ns:maximize-2" class="w-[1.125rem] h-[1.125rem]" />
          </ContentImageActionsButton>
        </ContentImageActions>
      </template>

      <VideoPlayer
        v-else
        :src="url"
        :width="props.width"
        :height="props.height"
        :poster="poster"
        custom-controls
        zoomable
        @zoom="$emit('zoom')"
      >
        <source :src="url" :type="type" />
        Twoja przeglądarka nie obsługuje odtwarzacza wideo.
      </VideoPlayer>
    </div>

    <figcaption
      v-if="caption"
      class="content-video__caption text-[0.5rem] leading-4 text-grey px-5 lg:px-0"
    >
      {{ caption }}
    </figcaption>
  </figure>
</template>
